import { render, staticRenderFns } from "./DetailsIns.vue?vue&type=template&id=fbd99be2"
import script from "./DetailsIns.vue?vue&type=script&lang=js"
export * from "./DetailsIns.vue?vue&type=script&lang=js"
import style0 from "./DetailsIns.vue?vue&type=style&index=0&id=fbd99be2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports